import React from 'react';
import { useState } from 'react';
// material
import {
    Table,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    TableHead,
    Box, Pagination
} from '@mui/material';
import GuestUserTableRow from './guestUserTableRow'
import { useSelector } from 'react-redux'
import Scrollbar from '../../../../Scrollbar';

export const TABLE_HEAD = [
    { id: 'id', label: 'S.No', alignRight: false, title:'S.No', field: 'id' },
    { id: 'cGuestID ', label: 'GuestID', alignRight: false, title: 'GuestID', field: 'cGuestID' },
    { id: 'cUserName', label: 'UserName', alignRight: false, title: 'UserName', field: 'cUserName' },
    { id: 'cRFID', label: 'RFID', alignRight: false, title: 'RFID', field: 'cRFID' }
];

const GuestUserTable = ({ searchText, searchVal }) => {

    const { GuestReducers: { viewGuestUserList } } = useSelector(state => state)
    let firstIndex = 0;

    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(4);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };

    const tableData = searchText ? searchVal : viewGuestUserList
    const isUserNotFound = tableData?.length === 0;

    return (
        <>
            <Box>
                <Scrollbar>
                    <TableContainer sx={{ overflow: 'unset' }}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                    {TABLE_HEAD.map((headCell) => {
                                        return (<TableCell
                                            key={headCell.id}
                                            align={headCell.alignRight ? 'right' : 'left'}
                                        >
                                            <Typography variant='t14_400'>
                                                {headCell.label}
                                            </Typography>
                                        </TableCell>
                                        )
                                    })}
                                    <TableCell align='right' >
                                        <Typography variant='t14_400'>
                                            Actions
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData?.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page)
                                    .map((m, i) => {
                                        return (
                                            <GuestUserTableRow key={m.id} rowData={m} />
                                        )
                                    }
                                    )}
                            </TableBody>
                            {isUserNotFound && (
                                <TableBody>
                                    <TableRow display='flex'>
                                        <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
            <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
                <Pagination
                    shape="rounded"
                    color='primary'
                    count={Math.ceil(tableData?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    )
}

export default GuestUserTable;